import React, { useEffect, useRef } from 'react'
import RoleInformation from './RoleInformation';
import PersonalInformation from './PersonalInformation';
import AddressInformation from './AddressInformation';
import FinancialInformation from './FinancialInformation';
import RegulatoryInformation from './RegulatoryInformation';
// import HouseholdReview from './HouseholdReview';
import { Grid, Step, StepLabel, Stepper, Typography } from '@mui/material';
import { useParams } from 'react-router';
import axiosInstance from 'custom-axios';
import { toast } from 'react-toastify';
import { useFormContext } from 'react-hook-form';
import { useFullPageLoader } from 'hooks/useFullPageLoader';

const HouseHoldStepper = ({ setParentErrorStepIndex, parentErrorStepIndex, setActiveChildStep, activeChildStep, setHouseHoldHomeComponent, activeParentStep, setActiveParentStep }) => {
    const { id } = useParams();
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const storedPermissions = localStorage.getItem('manager_permissions');
    const parsedPermissions = storedPermissions ? JSON.parse(storedPermissions) : {};
    const hasPermission = (permissionName) => Object.prototype.hasOwnProperty.call(parsedPermissions, permissionName);
    const householdSteps = [
        { label: 'Role', permission: 'Household Role', component: RoleInformation },
        { label: 'Personal Information', permission: 'Personal Information', component: PersonalInformation },
        { label: 'Address', permission: 'Address', component: AddressInformation },
        { label: 'Financial', permission: 'Financial', component: FinancialInformation },
        { label: 'Regulatory', permission: 'Regulatory', component: RegulatoryInformation }
    ];
    const childSteps = householdSteps
        .map((step, originalIndex) => ({ ...step, originalIndex }))
        .filter((step) => hasPermission(step.permission));

    const [houseHoldStepError, setHouseHoldStepError] = React.useState([false, false, false, false, false, false]); // Track errors for each step

    const { getValues } = useFormContext();

    // console.log(getValues())
    const step0Ref = useRef();
    const step1Ref = useRef();
    const step2Ref = useRef();

    let stepRefs = [step0Ref, step1Ref, step2Ref, undefined, undefined, undefined]; // Only steps with validation and undefined that no validation required.

    const clickOnHouseHoldChildStep = async (index) => {

        showLoader();

        const stepEndpoints = [
            'api/save-user-role-info',
            'api/save-user-personal-info',
            'api/save-user-address-info',
            'api/save-user-financial-info',
            'api/save-user-regulatory-info',
            'api/change-form-step'
        ];

        let isValid = true;
        let submitData;
        const currentStep = childSteps[activeChildStep];
        const originalIndex = currentStep.originalIndex;
        const endPoint = stepEndpoints[originalIndex];

        // Perform validation for steps with refs
        if (stepRefs[originalIndex]) {
            isValid = await stepRefs[originalIndex].current.triggerValidation();
        }

        let updatedErrors = [...houseHoldStepError];
        updatedErrors[originalIndex] = !isValid;
        setHouseHoldStepError(updatedErrors)

        const hasTrueValue1 = updatedErrors.some(value => value === true);

        const updatedErrorParentState = [...parentErrorStepIndex];

        if (hasTrueValue1) {
            updatedErrorParentState[0] = true; // Update index 1
        } else {
            updatedErrorParentState[0] = false; // Reset index 1
        }

        // console.log(updatedErrorParentState)

        if (endPoint === 'api/change-form-step') {
            // Submit without formData for the 'change-form-step' endpoint
            submitData = {
                child_household_error_step: updatedErrors,
                parent_error_step: updatedErrorParentState,
                user_id: id || 0,
                parent_step: 0,
                child_step: index
            };
        } else {
            // Default submit data including formData
            submitData = {
                ...getValues(),
                child_household_error_step: updatedErrors,
                parent_error_step: updatedErrorParentState,
                user_id: id || 0,
                parent_step: 0,
                child_step: index
            };
        }

        try {

            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status == 500) {
                toast.error(response.message)
                return;
            }

            setActiveChildStep(index)

        } catch (error) {
            toast.error(error?.message || 'Something went wrong. Please try again.');
            setActiveChildStep(index - 1)
        } finally {
            hideLoader();
        }

        // hideLoader();

    }
    // console.log()
    const getHouseholdSteps = (progress) => {
        const step = childSteps[progress];

        if (!step) {
            return null;
        }

        const StepComponent = step.component;
        const commonProps = {
            activeStep: activeChildStep,
            setActiveStep: setActiveChildStep
        };

        switch (step.permission) {
            case 'Role':
                return <StepComponent {...commonProps} roleRef={step0Ref} setHouseHoldHomeComponent={setHouseHoldHomeComponent} />;
            case 'Personal Information':
                return <StepComponent {...commonProps} personRef={step1Ref} />;
            case 'Address':
                return <StepComponent {...commonProps} addressRef={step2Ref} />;
            case 'Regulatory':
                return <StepComponent {...commonProps} setActiveParentStep={setActiveParentStep} />;
            default:
                return <StepComponent {...commonProps} />;
        }
    };

    const fetchAccountFormStep = async () => {

        try {

            const response = await axiosInstance.get(`api/fetch-form-step/${id}`);

            if (response.data) {

                const ChildErrorStepArray = response.data?.child_household_error_step
                    ? response.data.child_household_error_step
                        .split(",") // Split the string into an array
                        .map((value) => value === "1") // Convert "1" to true and "0" to false
                    : []; // Default to an empty array if null or undefined

                if (ChildErrorStepArray.length > 0) {
                    setHouseHoldStepError(ChildErrorStepArray);
                }

            }

        } catch (error) {
            // console.error(error.message);
        }
    };

    useEffect(() => {

        // Check if there are any true values in houseHoldStepError after it updates
        const hasTrueValue = houseHoldStepError.some(value => value === true);
        // console.log('in');
        setParentErrorStepIndex((prevState) => {
            const updatedState = [...prevState];

            if (hasTrueValue) {
                updatedState[0] = true; // Update index 0
            } else {
                updatedState[0] = false; // Reset index 0
            }

            return updatedState;
        });

    }, [houseHoldStepError]); // Run this effect whenever houseHoldStepError changes


    useEffect(() => {
        fetchAccountFormStep()
    }, [])
    return (
        <>
            {childSteps.length > 0 && activeChildStep !== childSteps.length ? (
                <>
                    <div className='client-form-box'>
                        <div className='border-solid-ced4da'>
                            <Grid item xs={12} sm={6} sx={{ paddingTop: '2.5rem' }}>
                                <Stepper activeStep={activeChildStep} alternativeLabel>

                                    {childSteps.map((step, index) => {

                                        const labelProps1 = {};

                                        if (houseHoldStepError[step.originalIndex]) {
                                            labelProps1.optional = (
                                                <Typography variant="caption" color="error">Error</Typography>
                                            );

                                            labelProps1.error = true;
                                        }

                                        return (
                                            <Step key={step.permission}>
                                                <StepLabel
                                                    {...labelProps1}
                                                    onClick={() => clickOnHouseHoldChildStep(index)}
                                                    className="cursor-pointer"
                                                >
                                                    {step.label}
                                                </StepLabel>
                                            </Step>
                                        )
                                    })}
                                </Stepper>
                            </Grid>
                            {getHouseholdSteps(activeChildStep)}
                        </div>
                    </div>
                </>
            ) : (
                null
            )
            }
            {loader}
        </>
    )
}

export default HouseHoldStepper
